// extracted by mini-css-extract-plugin
export default {"tabs":"tabs_tabs__iM2dl","tab":"tabs_tab__IBMBZ","active":"tabs_active__XKaAe"};